import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const Label = ({ fieldId, data }) => {
    var _a, _b;
    if (!data) {
        return null;
    }
    if (((_a = data.labelPlacement) === null || _a === void 0 ? void 0 : _a.toLowerCase()) === 'hidden_label' || ((_b = data.labelPlacement) === null || _b === void 0 ? void 0 : _b.toLowerCase()) === 'hidden') {
        return null;
    }
    return (_jsxs("label", { className: "form-duuf-label d-block mb-0", htmlFor: fieldId, children: [data.customLabel ? data.customLabel : data.label, data.isRequired && _jsx("span", { className: "form-duuf-label-mandatory", children: "*" })] }));
};
export default Label;
